import { GET_RIDEDETAILSPOLYLINE } from "resources/actionTypes";


const initialRideDetails = {
    userRideDetails: [],
    loading: false,
    error: null,
  };

  export function userRideDetailsPolylines(state = initialRideDetails, action) {
    switch (action.type) {
      case GET_RIDEDETAILSPOLYLINE.GET_RIDEDETAILSPOLYLINE_REQUESTED:
        return {
          ...state,
          loading: true,
        };
      case GET_RIDEDETAILSPOLYLINE.GET_RIDEDETAILSPOLYLINE_SUCCESS:
        return {
          ...state,
          loading: false,
          userRideDetails: action.userRideDetails,
        };
      case GET_RIDEDETAILSPOLYLINE.GET_RIDEDETAILSPOLYLINE_FAILED:
        return {
          ...state,
          loading: false,
          error: action.message,
        };
      default:
        return state;
    }
  }